"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSimpleCellRenderer = createSimpleCellRenderer;
exports.typeCellRenderer = exports.statusCellRenderer = exports.placementCellRenderer = exports.locationCellRenderer = exports.dueDateCellRenderer = exports.datetimeCellRenderer = exports.dateCellRenderer = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactTooltip = _interopRequireWildcard(require("@adsk/alloy-react-tooltip"));
var _alloyReactDatetime = require("@adsk/alloy-react-datetime");
var _dateUtils = require("../../../utils/data/dateUtils");
var _StatusDisplay = require("../../../input-field-components/StatusDisplay");
var _TypeDisplay = require("../../../input-field-components/TypeDropdown/TypeDisplay");
var _LocationDisplay = require("../../../input-field-components/LocationDisplay");
var _InlineValueDisplay = require("../../../utils/components/InlineValueDisplay");
var _DueDateDisplay = require("../../../input-field-components/DueDateDisplay");
var _InlineLoader = require("../../../utils/components/InlineLoader");
var _PlacementDisplay = require("../../../IssueDetailPanel/IssueDetailTabPanel/PlacementDisplay");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Wraps a function to create a CellRenderer function, that by default shows "-" is the data is nullish.
 */
function createSimpleCellRenderer(render) {
  return args => {
    const empty = !args.cellData;
    const value = !empty ? render(args) : null;
    return /*#__PURE__*/_react.default.createElement(_InlineValueDisplay.InlineValueDisplay, {
      empty: empty
    }, value);
  };
}

/**
 *
 * @param cellData - a date string of the format `YYYY-MM-DD`
 *
 */
const dateCellRenderer = exports.dateCellRenderer = createSimpleCellRenderer(_ref => {
  let {
    cellData
  } = _ref;
  return (0, _dateUtils.getDateStringAsDisplayText)(cellData);
});

/**
 *
 * @param cellData - an ISO datetime string, or anything else that `Date` accepts in its constructor
 */
const datetimeCellRenderer = exports.datetimeCellRenderer = createSimpleCellRenderer(_ref2 => {
  let {
    cellData
  } = _ref2;
  return (0, _alloyReactDatetime.displayDate)(new Date(cellData), {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
  });
});
const dueDateCellRenderer = exports.dueDateCellRenderer = createSimpleCellRenderer(_ref3 => {
  let {
    rowData
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_DueDateDisplay.DueDateDisplay, {
    dueDate: rowData.dueDate,
    closedBy: rowData.closedBy
  });
});
const statusCellRenderer = exports.statusCellRenderer = createSimpleCellRenderer(_ref4 => {
  let {
    cellData
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(_StatusDisplay.StatusDisplay, {
    status: cellData
  });
});
const typeCellRenderer = exports.typeCellRenderer = createSimpleCellRenderer(_ref5 => {
  let {
    cellData,
    rowData
  } = _ref5;
  if (!cellData.title || !cellData.code) {
    return _InlineValueDisplay.InlineValueDisplay.EMPTY;
  }
  return /*#__PURE__*/_react.default.createElement(_TypeDisplay.TypeDisplay, {
    status: rowData.status,
    stampCode: cellData.code,
    title: cellData.title,
    stampSize: 32,
    isMultiLineAllowed: false
  });
});
const locationCellRenderer = _ref6 => {
  let {
    cellData
  } = _ref6;
  return /*#__PURE__*/_react.default.createElement(_LocationDisplay.LocationDisplay, {
    locationId: cellData
  });
};
exports.locationCellRenderer = locationCellRenderer;
const placementCellRenderer = _ref7 => {
  let {
    cellData,
    rowData,
    container
  } = _ref7;
  if (cellData === undefined) {
    return /*#__PURE__*/_react.default.createElement(_InlineLoader.InlineLoader, {
      loaderStyle: _InlineLoader.LoaderStyle.Text
    });
  }
  if (!cellData) {
    return _InlineValueDisplay.InlineValueDisplay.EMPTY;
  }
  const isDocumentPlacement = rowData.isDocumentPlacement;
  const isSheetPlacement = rowData.isSheetPlacement;
  const documentTitle = cellData.name;
  const sheetTitle = cellData.name + (cellData.title ? " (".concat(cellData.title, ")") : "");
  const placementText = isSheetPlacement ? sheetTitle : document ? documentTitle : undefined;
  const placementLink = rowData.placementLinkFunction({
    projectId: rowData.projectId,
    productId: rowData.productId,
    sheet: isSheetPlacement ? cellData : undefined,
    issueId: rowData.id,
    document: isDocumentPlacement ? cellData : undefined
  });
  return /*#__PURE__*/_react.default.createElement(_alloyReactTooltip.OverflowTooltip, {
    style: {
      width: "100%"
    },
    autoTipOnEllipsis: true,
    variant: _alloyReactTooltip.default.VARIANTS.DARK,
    container: container,
    content: placementText
  }, /*#__PURE__*/_react.default.createElement(_PlacementDisplay.PlacementDisplay, {
    placementLink: placementLink,
    placementText: placementText,
    shouldShowLink: !rowData.deleted,
    issue: rowData
  }));
};
exports.placementCellRenderer = placementCellRenderer;
//# sourceMappingURL=cellRenderers.js.map